import type { TypographyProps } from "@mui/material";
import { Typography } from "@mui/material";

import type { SxProps, Theme } from "@mui/material/styles";

type HeaderProps = {
    text?: string;
    type?: TypographyProps['variant'];
    show?: boolean;
    sx?: SxProps<Theme>;
};

const Header = ({ text, type = 'h5', show = true, sx = {} }: HeaderProps) => {
    if (!show) return <></>;
    return <Typography variant={ type } sx={ sx }>{ text }</Typography>;
}

export default Header
